import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit, resource } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { IBbitI18n, IBbitPlaceBookingMetaResponse } from '@bbitgmbh/bbit.utils';
import { BbitWebsiteMetaDataService, BbitWebsiteService, I18nPipe } from '@bbitgmbh/website.sdk';
import { LoadingComponent } from '../../helper/loading/loading.component';
import { IBbitBookingOption, PlaceBookingService } from '../booking.service';
import { BookingOverlayService } from '../booking-overlay.service';

interface ILegalFile {
  _id: string;
  designation: IBbitI18n;
  url: string;
}

@Component({
  selector: 'app-booking-selection',
  templateUrl: './booking-selection.component.html',
  styleUrl: './booking-selection.component.scss',
  imports: [RouterLink, FormsModule, I18nPipe, AsyncPipe, LoadingComponent],
})
export class BookingSelectionComponent implements OnInit {
  booking = inject(PlaceBookingService);
  overlay = inject(BookingOverlayService);
  private _meta = inject(BbitWebsiteMetaDataService);

  public legalFiles = resource<ILegalFile[], void>({
    loader: async () => {
      const files: ILegalFile[] = [];
      const response = await this.booking.getLegalFiles();

      for (const o of response) {
        files.push({
          _id: o._id,
          designation: o.designation,
          url: this.booking.getDownloadUrl(o),
        });
      }
      return files;
    },
  });
  public bookingOptions = resource<IBbitBookingOption[], void>({
    loader: async () => {
      return this.booking.getBookingOptions();
    },
  });
  public meta = resource<IBbitPlaceBookingMetaResponse, void>({ loader: () => this.booking.getMeta() });
  public website = inject(BbitWebsiteService);

  async ngOnInit(): Promise<void> {
    this._meta.update({
      title: 'Schiessanlage',
      description: '',
    });
  }
}
